<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>售后维修/维保列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.description" placeholder="文字描述"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.nickname" placeholder="输入提交人信息"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.project" placeholder="输入工程项目"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.director" placeholder="输入项目负责人"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.phone" placeholder="输入联系人信息"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" plain icon="el-icon-refresh" @click="refresh()">刷新</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;" ref="questionTable">
      <el-table-column align="center" type="selection" width="60"></el-table-column>
      <el-table-column sortable prop="id" label="ID" width="60" show-overflow-tooltip></el-table-column>
      <el-table-column prop="nickname" label="提交者" show-overflow-tooltip></el-table-column>
      <el-table-column prop="description" label="文字描述" show-overflow-tooltip></el-table-column>
      <el-table-column prop="phone" label="联系人" show-overflow-tooltip></el-table-column>
      <el-table-column prop="project" label="工程项目" show-overflow-tooltip></el-table-column>
      <el-table-column prop="director" label="项目承接人" show-overflow-tooltip></el-table-column>
      <el-table-column prop="status" label="处理状态">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 1">已处理</div>
          <div v-else>未处理</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="60%" @click="closeDialog()">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="提交者" prop="nickname">
          <el-input size="small" v-model="editForm.nickname" auto-complete="off"
                    placeholder="提交者"></el-input>
        </el-form-item>
        <el-form-item label="文字描述" prop="description">
          <el-input size="small" v-model="editForm.description" auto-complete="off"
                    placeholder="文字描述"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="phone">
          <el-input size="small" v-model="editForm.phone" auto-complete="off"
                    placeholder="联系人"></el-input>
        </el-form-item>
        <el-form-item label="工程项目" prop="project">
          <el-input size="small" v-model="editForm.project" auto-complete="off"
                    placeholder="工程项目"></el-input>
        </el-form-item>
        <el-form-item label="项目承接人" prop="director">
          <el-input size="small" v-model="editForm.director" auto-complete="off"
                    placeholder="项目承接人"></el-input>
        </el-form-item>

        <el-form-item label="图片/视频信息" prop="director">
          <div v-for="item in editForm.image_url" :key="item.src">
            <el-image :src="item.src" v-if="item.type == 'image'" class="w80"></el-image>
            <video class="w80" controls="true" v-else>
              <source :src="item.src" type="video/mp4">
            </video>
          </div>
        </el-form-item>

        <el-form-item label="是否处理" prop="status">
          <el-switch v-model="editForm.status" active-color="#13ce66" inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('editForm')">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  import {repairDispose, repairHistory} from "../../api/userMG";

  export default {
    data() {
      return {
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        operatorVisible: false, //控制操作员页面显示与隐藏
        title: '',
        formInline: {
          page: 1,
          limit: 10,
          pageSize: 10,
          status: '',
          nickname: '',
          project: '',
          director: '',
          description: ''
        },
        editForm: {
          id: 0,
          status: null,
        },
        rules: {
          status: [
            {required: true, message: '请选择状态'}
          ],
        },
        uid: '',
        uids: [],
        managers: [],
        selectedId: [],
        showEdit: false,
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 1
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      refresh() {
        this.getdata(this.formInline)
      },
      batchEdit() {
        let selectedRows = this.$refs.questionTable.selection
        if (selectedRows.length == 0) {
          this.$message.error('请先选问题！')
          return false;
        }
        this.showEdit = true;
        let ids = []
        selectedRows.forEach(item => {
          ids.push(item.id)
        })
        this.selectedId = ids
      },
      getChangeUser(val) {
        this.editForm.uid = val
      },
      postDispose() {
        let selectedRows = this.$refs.questionTable.selection
        if (selectedRows.length == 0) {
          this.$message.error('请先选问题！')
          return false;
        }
        this.showMove = true;
        let ids = []
        selectedRows.forEach(item => {
          ids.push(item.id)
        })
        this.selectedId = ids
      },
      getdata(parameter) {
        this.loading = true
        repairHistory(parameter).then(res => {
          if (res.code == 200) {
            this.listData = res.items.data
            this.loading = false

            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.pageInfo.total
          }
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.formInline.pageSize = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.getdata(this.formInline)
      },
      //显示编辑界面
      handleEdit: function (row) {
        this.editFormVisible = true
        if (row != undefined) {
          let media = [];
          row.image_url = JSON.parse(row.image_url)
          row.image_url.forEach(item => {
            media.push({
              type: item.indexOf('.png') > -1 || item.indexOf('.jpg') > -1 ? 'image' : 'video',
              src: item
            })
          })
          row.image_url = media
          row.status = row.status == 1 ? true : false
          this.editForm = row
        }
      },
      // 编辑、增加页面保存方法
      submitForm(editData) {
        this.$refs[editData].validate(valid => {
          if (valid) {
            let row = this.editForm
            let uid = row.uid
            if (row.uid == '') {
              uid = this.$refs.getManager.selected.value
            }
            let params = {id: row.id, status: row.status == true ? 1 : 0, uid: uid}
            repairDispose(params)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.code == 200) {
                  this.$message({
                    type: 'success',
                    message: '保存成功！'
                  })
                  this.editForm = {
                    id: 0,
                    status: '',
                    uid: ''
                  }
                  this.uid = ''
                  this.getdata()
                } else {
                  this.$message({
                    type: 'info',
                    message: '保存失败！'
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('设备保存失败，请稍后再试！')
              })
          } else {
            return false
          }
        })
      },
      // 删除管理员
      deleteCourses(row) {
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteGeneralDevice({id: row.id})
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: '设备已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: '设备删除失败!'
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('设备删除失败，请稍后再试！')
            })
        })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      },
      // 关闭编辑、增加弹出框
      closeDialog(formName) {
        this.editFormVisible = false
        this.$refs[formName].resetFields()

        this.editForm = {
          id: 0,
          imei: '',
          memo: '',
          uid: ''
        }
        this.uid = ''
      }
    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }

  .w80 {
    width: 240px;
    height: 240px;
    float: left;
    margin-right: 20px;
  }
</style>







// WEBPACK FOOTER //
// src/views/repair/repair.vue